

















































































import Vue from "vue";
import { ToolTipPosition, TooltipMsgType } from "./tooltip.model";
import { EventBus } from "@/eventbus";
import { debounce } from "@/fp";
import { reactive, onMounted, computed, ref, Ref } from "@vue/composition-api";
export default Vue.extend({
  setup() {
    const data = reactive({
      duringAnimation: false,
      showToolTip: false,
      uniqueId: "",
      msg: "" as string | string[],
      type: "simple",
      asHtml: false,
      dimens: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        height: 0,
        width: 0,
      } as ClientRect,
      toolTipDimens: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        height: 0,
        width: 0,
      } as ClientRect,
      position: "top" as ToolTipPosition,
    });

    const elStyle = computed(() => {
      if (!data.dimens) {
        return {
          top: "0px",
          left: "0px",
        };
      }
      const el_width = data.dimens.right - data.dimens.left;
      const el_height = data.dimens.bottom - data.dimens.top;
      let deltaX = 0;
      let deltaY = 0;
      switch (data.position) {
        case "top":
          deltaY = -data.toolTipDimens.height - 15;
          deltaX = -data.toolTipDimens.width / 2 + el_width / 2;
          break;
        case "bottom":
          deltaY = data.dimens.height + 15;
          deltaX = -data.toolTipDimens.width / 2 + el_width / 2;
          break;
        case "left":
          deltaX = -data.toolTipDimens.width - 15;
          deltaY = -data.toolTipDimens.height / 2 + el_height / 2;
          break;
        case "right":
          deltaX = el_width + 15;
          deltaY = el_height / 2 - data.toolTipDimens.height / 2;
          break;
      }
      return {
        top: data.dimens.top + deltaY + "px",
        left: data.dimens.left + deltaX + "px",
        zIndex: data.showToolTip ? "300" : "-1",
      };
    });

    const rootEl: Ref<HTMLElement | null> = ref(null);

    const showFn = () => {
      if (data.duringAnimation) {
        return;
      }
      data.showToolTip = true;
      setTimeout(() => {
        data.toolTipDimens = (rootEl.value as HTMLElement).getBoundingClientRect();
      }, 0);

      /* 
          listen to the following to hide the tooltip
          1. mouse move outside of the client rect
          2. any mouse click outside of the tooltip.$el
          3. page change event 
       */
      document.addEventListener("mousemove", mouseMoveListener, true);
      document.addEventListener("click", mouseClickListener, true);
      document.addEventListener("keydown", keyDownListener, true);
    };
    const show = debounce(200)(function() {
      // @ts-ignore
      showFn();
    });

    const closeToolTip = () => {
      if (data.duringAnimation) {
        return;
      }
      removeEventListeners();
      data.showToolTip = false;
    };

    const removeEventListeners = () => {
      document.removeEventListener("mousemove", mouseMoveListener, true);
      document.removeEventListener("click", mouseClickListener, true);
      document.removeEventListener("keydown", keyDownListener, true);
    };

    const mouseMoveListener = (ev: MouseEvent) => {
      if (!checkIsInElArea(ev) && !checkIsInTooltipArea(ev)) {
        closeToolTip();
      }
    };
    const mouseClickListener = (ev: MouseEvent) => {
      if (!checkIsInTooltipArea(ev)) {
        closeToolTip();
      }
    };
    const keyDownListener = () => {
      closeToolTip();
    };

    const checkIsInElArea = (ev: MouseEvent): boolean => {
      const { clientX, clientY } = ev;
      const { left, right, top, bottom } = data.dimens;
      const insideX = clientX > left && clientX < right;
      const insideY = clientY > top && clientY < bottom;
      return insideX && insideY;
    };

    /*  const checkIsInTooltipArea = (ev: MouseEvent): boolean => {
      const { clientX, clientY } = ev;
      const { left, right, top, bottom } = data.toolTipDimens;
      const insideX = clientX > left && clientX < right;
      const insideY = clientY > top && clientY < bottom;
      return insideX && insideY;
    }; */

    const checkIsInTooltipArea = (ev: MouseEvent): boolean => {
      const DELTA_DIST = 20;
      const { clientX, clientY } = ev;
      const { left, right, top, bottom } = data.toolTipDimens;
      const insideX =
        clientX > left - DELTA_DIST && clientX < right + DELTA_DIST;
      const insideY =
        clientY > top - DELTA_DIST && clientY < bottom + DELTA_DIST;
      return insideX && insideY;
    };

    onMounted(() => {
      EventBus.listen(
        "tooltip",
        (payload: {
          id: string;
          msg: string;
          el: HTMLElement;
          position: ToolTipPosition;
          type: TooltipMsgType;
          asHtml: boolean;
        }) => {
          const {
            id,
            el,
            msg,
            position,
            type = "simple",
            asHtml = false,
          } = payload;
          data.uniqueId = id;
          data.msg = msg;
          data.type = type;
          data.asHtml = asHtml;
          // for some strange reason it didn't work otherwise...
          data.position = position;
          data.dimens = el.getBoundingClientRect();
          show();
        }
      );
      /*  EventBus.$on("tooltip-update", (payload: { id: string; msg: string }) => {
      if (this.uniqueId === payload.id && this.msg !== payload.msg) {
        this.msg = payload.msg;
      }
    }); */
    });

    return {
      rootEl,
      elStyle,
      data,
    };
  },
});
